export { IRR, NPV, PMT } from '@formulajs/formulajs'
